export default {
  // 标题
  title: "提示",

  // 描述
  description:
    "以下列表中均为余额更新失败的地址，点击下方再次更新余额按钮继续查询余额。",

  // 统计
  totalCount: "共计",
  totalData: "条数据",

  // 表格列名
  serialNumber: "序号",
  blockchain: "公链",
  address: "地址",

  // 按钮
  back: "返回",
  updateBalanceAgain: "再次更新余额",
};
